module.exports = __webpack_public_path__ + "static/media/save-offer.82718af3.svg";